import styled from "styled-components";

export const Content = styled.div`
  flex: 1;
  padding-bottom:12px;
  border: 1px solid #8A620A;
  background-color: #FCECC552;
  padding: 12px;
  border-radius:6px;
  display:flex;
  flex-direction:column;
  gap: 9px;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
